<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-05-11 11:37:19
 * @LastEditors: hexy
 * @LastEditTime: 2023-05-11 13:11:28
 * @Description: 未维护
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\dialog\unmaintainedDialog.vue
-->
<template>
  <el-dialog :visible.sync="unmaintainedDialog" width="1500px" :close-on-click-modal="false" :before-close="close" @open="openMethod">
    <span v-if="showType == 2" slot="title" class="dialog-title">生成月报价</span>
    <span v-else slot="title" class="dialog-title">生成结算价</span>
    <div class="dialoginfo">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 10px">
        <el-button class="bottom_all" style="margin-right: 24px" @click="add()">添加</el-button>
      </div>
      <div style="height: 500px; overflow-y: auto">
        <div>
          <el-table ref="table1" :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="380" :data="tableData.specialPrices" tooltip-effect="dark">
            <el-table-column
              v-for="(item, index) in table"
              :key="index"
              :prop="item.prop"
              :label="item.prop == 'settlementConfirmPrice' ? (showType == 1 ? '本期确认结算价（元/m³）' : '本期确认月报价（元/m³）') : item.label"
              :width="item.width"
              align="center"
              :fixed="item.label == '操作' ? 'right' : false"
            >
              <template slot-scope="scope">
                <span v-if="item.label == '强度等级'">
                  <el-select v-model="scope.row.strengthGradeId" placeholder="请选择" style="width: 100px">
                    <el-option v-for="item in config_options.strengthGrade" :key="item.id" :label="item.name" :value="item.id" @click.native="selectStrengthGradeFun(scope.$index, item)"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '性能等级'">
                  <el-select v-model="scope.row.performanceGrade" multiple placeholder="请选择" value-key="id" style="width: 100px">
                    <el-option v-for="item in config_options.performanceGrade" :key="item.id" :label="item.name" :value="item"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '材料要求'">
                  <el-select v-model="scope.row.meterialRequirements" multiple placeholder="请选择" value-key="id" style="width: 100px">
                    <el-option v-for="item in config_options.meterialRequirements" :key="item.id" :label="item.name" :value="item"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '特殊要求'">
                  <el-select v-model="scope.row.specialRequirements" multiple placeholder="请选择" value-key="id" style="width: 100px">
                    <el-option v-for="item in config_options.specialRequirements" :key="item.id" :label="item.name" :value="item"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '外加剂要求'">
                  <el-select v-model="scope.row.admixtureRequirements" multiple placeholder="请选择" value-key="id" style="width: 100px">
                    <el-option v-for="item in config_options.admixtureRequirements" :key="item.id" :label="item.name" :value="item"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '其他要求'">
                  <el-select v-model="scope.row.otherRequirements" multiple placeholder="请选择" value-key="id" style="width: 100px">
                    <el-option v-for="item in config_options.otherRequirements" :key="item.id" :label="item.name" :value="item"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.prop == 'settlementConfirmPrice'">
                  <el-input
                    v-model="scope.row.settlementConfirmPrice"
                    type="Number"
                    style="width: 100%"
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                    @input="scope.row.invoiceMoney = $regExp.checkNum(scope.row.invoiceMoney)"
                    @blur="scope.row.invoiceMoney = $regExp.blurCheckNum(scope.row.invoiceMoney)"
                  >
                  </el-input>
                </span>
                <div v-else>
                  <el-button class="bottom_two" size="mini" @click="deleteFun(scope.$index)"> 删除 </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close()">取 消</el-button>
      <el-button class="bottom_all" style="margin-left: 24px" @click="save()">确 定</el-button>
    </span>
  </el-dialog>
</template>
  
  <script>
import { queryDisclose } from "@/api/internetSales/engineeringControl.js";
import { queryPriceDetail, saveOrUpdate } from "@/api/internetSales/monthlyReportUnitRecord.js";
export default {
  components: {},
  props: {
    unmaintainedDialog: {
      type: Boolean,
      default: false,
    },
    //1混凝土 2月报
    showType: {
      type: Number,
      default: 1,
    },
    //1调价周期记录 2信息价期数
    monthPriceType: {
      type: Number,
      default: 1,
    },
    engineeringId: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
      table: [
        { label: "强度等级", width: "auto", prop: "strengthGradeId", status: true },
        { label: "性能等级", width: "auto", prop: "performanceGrade", status: true },
        { label: "材料要求", width: "auto", prop: "meterialRequirements", status: true },
        { label: "特殊要求", width: "auto", prop: "specialRequirements", status: true },
        { label: "外加剂要求", width: "auto", prop: "admixtureRequirements", status: true },
        { label: "其他要求", width: "auto", prop: "otherRequirements", status: true },
        { label: "本期确认结算价（元/m³）", width: "auto", prop: "settlementConfirmPrice", status: true },
        { label: "操作", width: "auto", prop: "", status: true },
      ],
      tableData_other: [],
      table_other_options: [
        { value: 1, label: "按车收费" },
        { value: 0, label: "不收费" },
        { value: 2, label: "按方量收费" },
      ],
      config_options: {
        strengthGrade: [],
        performanceGrade: [],
        meterialRequirements: [],
        otherRequirements: [],
        admixtureRequirements: [],
        specialRequirements: [],
      },
    };
  },
  methods: {
    openMethod() {
      this.queryDiscloseFun();
      this.queryPriceDetail();
    },
    queryPriceDetail() {
      queryPriceDetail({ dataId: this.data.id, type: this.monthPriceType }).then(res => {
        if (res.code == 1001) {
          this.tableData = res.data;
          if (!this.tableData.specialPrices) {
            this.tableData.specialPrices = [];
          } else {
            this.tableToArr();
          }
          this.$refs.table1.doLayout();
        }
      });
    },
    close() {
      this.$emit("closeUnmaintainedDialog", false);
    },
    add() {
      let specialPrices = {
        strengthGradeId: "",
        strengthGrade: "",
        performanceGrade: [],
        performanceGradeId: "",
        meterialRequirements: [],
        meterialRequirementsId: "",
        specialRequirements: [],
        specialRequirementsId: "",
        admixtureRequirements: [],
        admixtureRequirementsId: "",
        otherRequirements: [],
        otherRequirementsId: "",
        settlementPrice: "",
        settlementConfirmPrice: "",
        lastConfirmPrice: "",
        productName: "",
        productId: "",
        id: "",
        cycleId: "",
      };
      this.tableData.specialPrices.push(specialPrices);
      this.$refs.table1.doLayout();
    },
    deleteFun(index) {
      this.tableData.specialPrices.splice(index, 1);
    },
    selectStrengthGradeFun(index, val) {
      this.tableData.specialPrices[index].strengthGrade = val.name;
      this.tableData.specialPrices[index].strengthGradeId = val.id;
    },
    queryDiscloseFun() {
      queryDisclose({ engId: this.monthPriceType == 2 ? this.engineeringId : this.data.engineeringId }).then(res => {
        if (res.code == 1001) {
          this.config_options = res.data;
        }
      });
    },
    //table数据字符串转数组
    tableToArr() {
      this.tableData.specialPrices.forEach(item => {
        item.performanceGrade = JSON.parse(item.performanceGrade);
        item.meterialRequirements = JSON.parse(item.meterialRequirements);
        item.specialRequirements = JSON.parse(item.specialRequirements);
        item.admixtureRequirements = JSON.parse(item.admixtureRequirements);
        item.otherRequirements = JSON.parse(item.otherRequirements);
      });
    },
    save() {
      let type = false;
      let type2 = false;
      this.tableData.specialPrices.forEach(item => {
        if (!item.strengthGradeId || (!item.settlementConfirmPrice && item.settlementConfirmPrice !== 0)) {
          type = true;
        }
        if (item.settlementConfirmPrice < 150 || item.settlementConfirmPrice > 2000) {
          type2 = true;
        }
      });
      if (type) {
        this.$message.warning(`强度等级及本期确认${this.showType == 1 ? "结算" : "月报"}价不能为空!`);
        return;
      }
      if (type2) {
        this.$message.warning("价格范围为200-2000！");
        return;
      }
      this.tableData.specialPrices.forEach(item => {
        //获取 id 或 name拼接成的字符串 --1.性能等级
        let performanceGradeName = "";
        let performanceGradeIdArr = [];
        let performanceGradeNameArr = [];
        if (item.performanceGrade.length > 0) {
          performanceGradeIdArr = Array.from(item.performanceGrade, ({ id }) => id);
          performanceGradeNameArr = Array.from(item.performanceGrade, ({ name }) => name);
        }
        item.performanceGradeId = performanceGradeIdArr.join(",");
        performanceGradeName = performanceGradeNameArr.join("");
        item.performanceGrade = JSON.stringify(item.performanceGrade);
        //获取 id 或 name拼接成的字符串 --2.材料要求
        let meterialRequirementsName = "";
        let meterialRequirementsIdArr = [];
        let meterialRequirementsNameArr = [];
        if (item.meterialRequirements.length > 0) {
          meterialRequirementsIdArr = Array.from(item.meterialRequirements, ({ id }) => id);
          meterialRequirementsNameArr = Array.from(item.meterialRequirements, ({ name }) => name);
        }
        item.meterialRequirementsId = meterialRequirementsIdArr.join(",");
        meterialRequirementsName = meterialRequirementsNameArr.join("");
        item.meterialRequirements = JSON.stringify(item.meterialRequirements);
        //获取 id 或 name拼接成的字符串 --3.特殊要求
        let specialRequirementsName = "";
        let specialRequirementsIdArr = [];
        let specialRequirementsNameArr = [];
        if (item.specialRequirements.length > 0) {
          specialRequirementsIdArr = Array.from(item.specialRequirements, ({ id }) => id);
          specialRequirementsNameArr = Array.from(item.specialRequirements, ({ name }) => name);
        }
        item.specialRequirementsId = specialRequirementsIdArr.join(",");
        specialRequirementsName = specialRequirementsNameArr.join("");
        item.specialRequirements = JSON.stringify(item.specialRequirements);
        //获取 id 或 name拼接成的字符串 --4.外加剂要求
        let admixtureRequirementsName = "";
        let admixtureRequirementsIdArr = [];
        let admixtureRequirementsNameArr = [];
        if (item.admixtureRequirements.length > 0) {
          admixtureRequirementsIdArr = Array.from(item.admixtureRequirements, ({ id }) => id);
          admixtureRequirementsNameArr = Array.from(item.admixtureRequirements, ({ name }) => name);
        }
        item.admixtureRequirementsId = admixtureRequirementsIdArr.join(",");
        admixtureRequirementsName = admixtureRequirementsNameArr.join("");
        item.admixtureRequirements = JSON.stringify(item.admixtureRequirements);
        //获取 id 或 name拼接成的字符串 --5.其他要求
        let otherRequirementsName = "";
        let otherRequirementsIdArr = [];
        let otherRequirementsNameArr = [];
        if (item.otherRequirements.length > 0) {
          otherRequirementsIdArr = Array.from(item.otherRequirements, ({ id }) => id);
          otherRequirementsNameArr = Array.from(item.otherRequirements, ({ name }) => name);
        }
        item.otherRequirementsId = otherRequirementsIdArr.join(",");
        otherRequirementsName = otherRequirementsNameArr.join("");
        item.otherRequirements = JSON.stringify(item.otherRequirements);

        item.productName =
          item.strengthGrade +
          (performanceGradeName ? performanceGradeName : "") +
          (meterialRequirementsName ? meterialRequirementsName : "") +
          (specialRequirementsName ? specialRequirementsName : "") +
          (admixtureRequirementsName ? admixtureRequirementsName : "") +
          (otherRequirementsName ? otherRequirementsName : "");

        item.productId =
          item.strengthGradeId +
          (item.performanceGradeId ? "," + item.performanceGradeId : "") +
          (item.meterialRequirementsId ? "," + item.meterialRequirementsId : "") +
          (item.specialRequirementsId ? "," + item.specialRequirementsId : "") +
          (item.admixtureRequirementsId ? "," + item.admixtureRequirementsId : "") +
          (item.otherRequirementsId ? "," + item.otherRequirementsId : "");
      });
      console.log(this.tableData);
      this.tableData["adjustPriceType"] = this.monthPriceType == 1 ? this.data.adjustPriceType : "";
      this.tableData["dataId"] = this.data.id;
      this.tableData["dataSource"] = this.monthPriceType;
      saveOrUpdate(this.tableData)
        .then(res => {
          if (res.code == 1001) {
            this.$message.success("保存成功!");
            this.close();
          }
        })
        .catch(() => {
          this.tableToArr();
        });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>